export default __webpack_public_path__ + "static/media/online-facilitation.567ff223.pdf";